import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * TransitionShell — unified loader shown between async routing transitions.
 *
 * Replaces the multiple ad-hoc loaders that previously caused "flashes" between
 * OnboardingGuard transitions (PostCheckoutLoading, raw `return null`, MUI
 * CircularProgress alone). One visual language for every wait-for-async moment
 * in the onboarding/billing flow.
 *
 * Layout: normal block (not fixed) so it integrates with the parent route's
 * layout context. Callers ensure no shell leaks behind it by NOT rendering
 * sidebars/headers when in-transition (see MainLayout.shouldUseAppShell guards).
 *
 * Doctrine: PRP `flash-diagnostics-onboarding-flow` (2026-05-26, D3).
 */
const TransitionShell = ({ label = '', sublabel = '' }) => (
  <Box
    sx={{
      minHeight: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      bgcolor: 'background.default',
    }}
    data-testid="transition-shell"
  >
    <CircularProgress size={40} />
    {label && (
      <Typography variant="body1" color="text.secondary">
        {label}
      </Typography>
    )}
    {sublabel && (
      <Typography variant="caption" color="text.disabled">
        {sublabel}
      </Typography>
    )}
  </Box>
);

export default TransitionShell;
